import React from 'react';
import '../../styles/GroupScoreContent.css';

function GroupScoreContent() {
  // In a real application, this data would likely come from an API
  const groupName = 'Example Group';
  const currentDate = new Date().toLocaleDateString();
  const scores = [
    { module: 'PRACTICAL ACCOUNTING', score: 80 },
    { module: 'PRACTICAL ECONOMICS', score: 60 },
    { module: 'ART OF INVESTMENT', score: 75 },
    { module: 'OPTIMISATION', score: 45 },
  ];

  const averageScore = scores.reduce((sum, item) => sum + item.score, 0) / scores.length;

  return (
    <div className="group-score-content">
      <h2>Group Score</h2>
      <div className="score-overview">
        <p>The average score for <strong>{groupName}</strong> as of <strong>{currentDate}</strong> is:</p>
        <div className="average-score">{averageScore}%</div>
        <button className="calculation-button">CALCULATION OF THE SCORE</button>
      </div>

      <div className="score-breakdown">
        <table>
          <thead>
            <tr>
              <th>PRACTICAL ACCOUNTING</th>
              <th>PRACTICAL ECONOMICS</th>
              <th>ART OF INVESTMENT</th>
              <th>OPTIMISATION</th>
              <th>AVERAGE SCORE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{scores.find(s => s.module === 'PRACTICAL ACCOUNTING')?.score}%</td>
              <td>{scores.find(s => s.module === 'PRACTICAL ECONOMICS')?.score}%</td>
              <td>{scores.find(s => s.module === 'ART OF INVESTMENT')?.score}%</td>
              <td>{scores.find(s => s.module === 'OPTIMISATION')?.score}%</td>
              <td className="average">{averageScore}%</td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  );
}

export default GroupScoreContent;